module.exports = __webpack_public_path__ + "static/media/rnb_logo.4acc5741.svg";